import { getAPIBaseURL } from './helpers'
import { getData } from './request'
import { needsEmployerOnboarding } from '../employer/employerOnboardingUtils'

export const persistEmploymeSession = (userData) => {
  if (userData) {
    localStorage.setItem('employmeUser', JSON.stringify(userData))
  }
  sessionStorage.setItem('employme-active', '1')
}

export const navigateAfterLogin = async (userData, navigate) => {
  persistEmploymeSession(userData)

  const storedUser = JSON.parse(localStorage.getItem('employmeUser') || 'null')
  if (!storedUser) {
    throw new Error('Failed to save session')
  }

  if (storedUser.role === 'JOB_SEEKER') {
    try {
      const profileUrl = `${getAPIBaseURL()}/employme/jobseeker/profile`
      const { error: profileError, result: profileResult } = await getData(profileUrl, {}, {})
      if (!profileError && profileResult?.status === 200) {
        const profile = profileResult.data?.data
        if (profile?.cvUrl) {
          navigate('/jobs', { replace: true })
          return
        }
      }
      navigate('/jobs/onboarding', { replace: true })
    } catch {
      navigate('/jobs/onboarding', { replace: true })
    }
    return
  }

  try {
    const companyUrl = `${getAPIBaseURL()}/employme/employer/company`
    const { error: companyError, result: companyResult } = await getData(companyUrl, {}, {})
    if (!companyError && companyResult?.status === 200) {
      const company = companyResult.data?.data || companyResult.data
      if (needsEmployerOnboarding(company)) {
        navigate('/employer/onboarding', { replace: true })
        return
      }
    } else {
      navigate('/employer/onboarding', { replace: true })
      return
    }
  } catch {
    navigate('/employer/onboarding', { replace: true })
    return
  }

  navigate('/employer/dashboard', { replace: true })
}
